module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('p', [_vm._v("\n      时尚新娘\n            时尚新娘(www.ccbride.com)是时尚集团下属高端婚尚品牌。\n            时尚新娘定位高端，引领时尚、传递国际最新潮流的婚尚生活杂志，拥有国际版权强大支持。 用一本杂志的力量实现一个时代的新婚时尚梦想，给你人生中最美的一天，和幸福的很多天。\n            顺应媒体发展趋势，时尚新娘以杂志、网站、微博、微信、数字杂志为载体开启新媒体互动时代，最全面的婚尚资讯平台、更多的互动体验、最实用的婚礼筹备指南，随时随地定义幸福！\n\n时尚传媒集团\n            时尚传媒集团（原时尚杂志社）诞生于1993年，是中国最大的高档期刊传媒集团之一。其业务涵盖广泛，在书刊编辑、出版、广告、印刷、发行等方面形成立体化规模经营。特别是“国际视野、本土意识”的经营理念，使其跟国际众多著名杂志进行了版权合作，并在合作交流中壮大了“时尚”品牌，完全自创的本土杂志和国外授权的合作杂志共同成长，相得益彰，使时尚传媒集团成为中国期刊界独特的代表。\n\n\n手机：186-1105-2766\n电话：010-6589-5819\n邮箱：wangxin@cosmo.love\n\n客服热线：400-900-8520\n     ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f1cd4ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutUs.vue
// module id = 607
// module chunks = 1